// eslint-disable-next-line import/prefer-default-export
export * from 'SourceRoute/MyAccount/MyAccount.config';

export const CUSTOMER = 'customer';
export const ONE_SECOND = 1000;
export const DASHBOARD = 'dashboard';
export const MY_ACCOUNT_URL = '/my-account';
